import { BIBLE_BOOKS } from '../data/bibleBooks';

// Strip everything to a comparable key: lowercase, only letters/digits/umlauts.
// "1. Mose" -> "1mose", "Joh." -> "joh", "1Kor" -> "1kor"
const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9äöüß]/g, '');

const ALIAS_MAP = (() => {
  const map = new Map();
  BIBLE_BOOKS.forEach(book => {
    new Set([book.name, book.label, ...(book.aliases || [])]).forEach(a => {
      const key = normalize(a);
      if (key) map.set(key, book);
    });
  });
  return map;
})();

export function findBook(text) {
  return ALIAS_MAP.get(normalize(text)) || null;
}

// Parse a typed string into a Bible reference, or return null if it is not one.
// Accepts: "Johannes 3,16" · "Joh 3:16" · "1. Mose 1,1" · "Psalm 23" ·
//          "Römer 8,28-39" · or a bare book name like "Johannes".
export function parseReference(input) {
  if (!input) return null;
  const s = input.trim();
  if (!s) return null;

  // Bare book name -> chapter 1
  const bare = findBook(s);
  if (bare) {
    return { id: bare.id, book: bare.name, label: bare.label, chapter: 1, verse: null };
  }

  // <book> <chapter>[ ,:/space <verse>][ - <verse>]
  const m = s.match(/^(.+?)[\s.]*(\d{1,3})(?:\s*[:,\s]\s*(\d{1,3}))?(?:\s*[-–]\s*\d{1,3})?$/);
  if (!m) return null;

  const book = findBook(m[1]);
  if (!book) return null;

  const chapter = parseInt(m[2], 10);
  if (!chapter || chapter < 1 || chapter > book.chapters) return null;

  const verse = m[3] ? parseInt(m[3], 10) : null;
  return { id: book.id, book: book.name, label: book.label, chapter, verse };
}
